import { MAP_ELEMENT_TYPES } from '../../../../constants/graph';
import MapElementModal from '../../../graph/MapElementModal';
import { CRUD_OPERATION_TYPES } from '../common/constants';
import screens from '../common/screens';
import { DataActionProvider } from '../contextProviders/DataActionProvider';
import { ListenerProvider } from '../contextProviders/ListenerProvider';
import {
    type MapElementConfigProps,
    MapElementProvider,
} from '../contextProviders/MapElementProvider';
import SaveRouter from './SaveRouter';

const Save = (props: MapElementConfigProps) => {
    return (
        <MapElementProvider
            {...props}
            defaultScreen={screens.save}
            elementType={MAP_ELEMENT_TYPES.databaseSave}
            isLoading={false}
        >
            <MapElementModal>
                <DataActionProvider
                    defaultScreen={screens.save}
                    crudOperationType={CRUD_OPERATION_TYPES['save']}
                >
                    <ListenerProvider defaultScreen={screens.save}>
                        <SaveRouter />
                    </ListenerProvider>
                </DataActionProvider>
            </MapElementModal>
        </MapElementProvider>
    );
};

export default Save;
